import { Suspense } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { useSetAnalyticsGlobal } from '@cast/analytics';

import { SuspenseLoader } from 'components/loaders';
import { ProtectedRoute } from 'components/router';
import { flattenNavItems, renderConfigRoutes } from '@oneclick/routing';

import { OVERVIEW_ROUTE_CONFIG } from './overviewRouteConfig';

const overviewPages = flattenNavItems(OVERVIEW_ROUTE_CONFIG);

export const OverviewController = () => {
  useSetAnalyticsGlobal('feature', 'Overview');

  return (
    <Suspense fallback={<SuspenseLoader />}>
      <Routes>
        <Route
          element={<ProtectedRoute subject="ClusterAutomationNewDashboard" />}
        >
          <Route
            element={<ProtectedRoute subject="OrganizationCostMonitoring" />}
          >
            {renderConfigRoutes({ pages: overviewPages, suspense: false })}
          </Route>
        </Route>
        <Route index element={<Navigate to="organization" replace />} />
        <Route path="*" element={<Navigate to="organization" replace />} />
      </Routes>
    </Suspense>
  );
};
